import { motion } from "framer-motion";
import colors from "../../styles/colors";
import Button from "../Button";
import { useTranslation } from "react-i18next";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section
      className="relative w-full font-serif flex flex-col md:flex-row items-center justify-center px-8 lg:px-20 py-20 bg-lightCream"
      style={{ color: colors.darkBrown }}
    >
      {/* Bal oldal: Szöveg */}
      <motion.div
        className="relative z-10 max-w-xl text-center md:text-left"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.5 }}
      >
        <h2 className="lg:text-6xl text-4xl md:text-5xl mb-6">{t("aboutSection.title")}</h2>
        <p className="lg:text-2xl text-lg md:text-xl mb-6 md:p-2">
          {t("aboutSection.text")}
        </p>
        <Button to={"/about"} text={t("aboutSection.button")} />
      </motion.div>

      {/* Jobb oldal: Kép */}
      <motion.div
        className="relative w-full md:w-[450px] h-[350px] md:h-[400px] flex items-center justify-center 
        rounded-2xl shadow-lg overflow-hidden mt-10 md:mt-0"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.5 }}
        style={{ backgroundColor: colors.pastelCream }}
      >
        <img
          src="/assets/images/home/AboutSection/about_us_main.webp"
          alt="About Us"
          className="w-full h-full object-cover rounded-2xl"
        />
      </motion.div>
    </section>
  );
};

export default AboutSection;
